var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2709_194253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8246 6.00333C11.8246 6.1313 11.7758 6.25924 11.6781 6.35677L7.35585 10.7065C7.2582 10.8041 7.13023 10.8529 7.00242 10.8529C6.8746 10.8529 6.74648 10.8033 6.6496 10.7065L4.32461 8.38458C4.22773 8.28771 4.17773 8.15958 4.17773 8.00333C4.17773 7.87536 4.22655 7.74743 4.32423 7.64989L4.67767 7.29646C4.77773 7.22521 4.87773 7.17833 5.03086 7.17833C5.18398 7.17833 5.28711 7.22521 5.38711 7.32208L7.00335 8.93833L10.619 5.32271C10.7166 5.22508 10.8446 5.17627 10.9724 5.17627C11.1002 5.17627 11.2283 5.22508 11.3258 5.32271L11.6793 5.67614C11.7777 5.77521 11.8246 5.90333 11.8246 6.00333Z",
    fill: "#304A5C",
    className: "fill-primary"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    className: "fill-secondary",
    d: "M14.5781 2.61621L8.57812 0.116207C8.42578 0.0527383 8.16687 0.000488281 8.00187 0.000488281C7.83587 0.000488281 7.57844 0.0527383 7.425 0.116207L1.42531 2.61621C0.865625 2.84714 0.5 3.39402 0.5 3.97214C0.5 12.0378 6.4125 16.0003 7.99687 16.0003C9.59687 16.0003 15.5 11.994 15.5 3.97214C15.5 3.39402 15.1344 2.84714 14.5781 2.61621ZM11.825 6.0034C11.825 6.13136 11.7762 6.2593 11.6785 6.35683L7.35625 10.7065C7.25859 10.8041 7.13062 10.853 7.00281 10.853C6.875 10.853 6.74688 10.8034 6.65 10.7065L4.325 8.38465C4.22812 8.28777 4.17812 8.15965 4.17812 8.0034C4.17812 7.87543 4.22694 7.74749 4.32463 7.64996L4.67806 7.29652C4.77812 7.22527 4.87812 7.1784 5.03125 7.1784C5.18438 7.1784 5.2875 7.22527 5.3875 7.32215L7.00375 8.9384L10.6194 5.32277C10.717 5.22515 10.845 5.17633 10.9728 5.17633C11.1006 5.17633 11.2287 5.22515 11.3263 5.32277L11.6797 5.67621C11.7781 5.77527 11.825 5.9034 11.825 6.0034Z",
    fill: "#304A5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2709_194253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoShield);
export default __webpack_public_path__ + "static/media/ico-shield.ff2c0f0ef027b822580303bb1ffdfeae.svg";
export { ForwardRef as ReactComponent };